<script>
export default {
  methods: {
    compileBranchDescriptionForGoogleMapMarker(openingHours, description) {
      const string1 =
        openingHours && this.$themeSettings.components.BranchesMap.markers.displayOpeningHours
          ? `<div class="BranchMarkerContent_openingHours">${openingHours}</div>`
          : ''
      const string2 = description ? `<div class="BranchMarkerContent_description">${description}</div>` : ''
      return string1 + string2
    },
  },
}
</script>
